import { DetailAction } from '../DetailAction';
import { CreateEditRecordingDialog } from '../../../../pages/detail/recording/CreateEditRecordingDialog';
import { SubscriptionSettings, SubscriptionTypes } from './SubscriptionSettings.types';
import {
  DetailTranslationKeys,
  ErrorTranslationKeys,
  PopupTranslationKeys,
} from '../../../../api/models/TranslationKeys';
import { Backend } from '../../../../api/Backend';
import { ISubscription, Recording } from '../../../../api/user/RecordingApi.types';

export class EpgEditRecordingAction extends DetailAction {
  private programTitle: string;
  private programId: string;
  private recording: Recording;
  private subscription: ISubscription | undefined;
  constructor(backend: Backend, programTitle: string, programId: string, recording: Recording) {
    super(backend);
    this.programTitle = programTitle;
    this.programId = programId;
    this.recording = recording;
  }

  override doAction() {
    if (this.recording && this.recording.isPlanned()) {
      this._backend.cachedRecordingsApi.subscription(this._backend, this.recording).then(sub => {
        this.subscription = sub;
        const type = this.recording.programSubscription
          ? SubscriptionTypes.PROGRAM
          : this.recording.seasonSubscription
          ? SubscriptionTypes.SEASON
          : SubscriptionTypes.SERIES;

        if (sub) {
          const settings = new SubscriptionSettings(
            this._backend,
            sub.device,
            type,
            sub.beginBuffer,
            sub.endBuffer,
            sub.deleteProtected
          );
          this.openDialog(settings);
        }
      });
    } else if (this.recording) {
      const settings = new SubscriptionSettings(
        this._backend,
        undefined,
        undefined,
        this.recording.beginBuffer,
        this.recording.endBuffer,
        this.recording.deleteProtected
      );
      this.openDialog(settings);
    } else {
      throw new Error('No recording');
    }
  }

  openDialog(subscriptionSettings: SubscriptionSettings) {
    this.owner?.fireAncestors('$openDialog', {
      type: CreateEditRecordingDialog,
      showTypeOption: false,
      showBufferOptions: this.recording && this.recording.isPlanned(),
      backend: this._backend,
      subscriptionSettings: subscriptionSettings,
      onSuccess: this.onConfirm.bind(this),
      onCancel: undefined,
      buttons: {
        confirm: this._backend.translations.forKey(PopupTranslationKeys.popup_btn_ok),
        cancel: this._backend.translations.forKey(PopupTranslationKeys.popup_btn_cancel),
      },
      title: this._backend.translations.forKey(DetailTranslationKeys.detail_recording_edit_popup_title),
      recordingTitle: this.programTitle,
    });
  }

  onConfirm(settings: SubscriptionSettings) {
    if (this.recording && this.recording.isPlanned() && this.subscription && settings.deviceId) {
      const oldDevice = this.subscription.device;
      this.subscription.device = settings.deviceId;
      this.subscription.beginBuffer = settings.beginBuffer;
      this.subscription.endBuffer = settings.endBuffer;
      this.subscription.deleteProtected = settings.deleteProtected;

      this._backend.cachedRecordingsApi
        .editSubscription(this._backend, oldDevice, settings.type, this.subscription)
        .then(() => this.owner?.fireAncestors('$reloadDetailContent'))
        .catch(() => {
          this.owner?.fireAncestors(
            '$showMessage',
            this._backend.translations.forKey(ErrorTranslationKeys.error_recording_edit_failed)
          );
        });
    } else if (this.recording) {
      if (this.recording.deleteProtected !== settings.deleteProtected) {
        this.recording.deleteProtected = settings.deleteProtected;
        this._backend.cachedRecordingsApi
          .editRecording(this._backend, this.recording)
          .then(() => this.owner?.fireAncestors('$reloadDetailContent'))
          .catch(() => {
            this.owner?.fireAncestors(
              '$showMessage',
              this._backend.translations.forKey(ErrorTranslationKeys.error_recording_edit_failed)
            );
          });
      }
    }
  }
}
